export default "__VITE_PUBLIC_ASSET__d3a7c239__"